export default "__VITE_ASSET__jwVUQ51wohRe3vUI64H48w__"